export { default as DeviceGoogleLogout } from "./DeviceGoogleLogout";



// WEBPACK FOOTER //
// ./src/modules/menu/components/deviceGoogleLogout/index.js